'use client';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';
import { useGSAP } from '@gsap/react';

// Registered once here so every scroll scene imports the same configured instance.
gsap.registerPlugin(ScrollTrigger, SplitText, ScrambleTextPlugin, useGSAP);

// A touch browser's toolbar sliding away is not a resize worth re-measuring for.
ScrollTrigger.config({ ignoreMobileResize: true });

// Layout measured before the web fonts arrive can be slightly off, so measure
// once more when they land — but "safely": a refresh rewrites the scroll
// position, so it must wait for the scroll to end, never cut into one.
if (typeof document !== 'undefined' && document.fonts && document.fonts.status !== 'loaded') {
  document.fonts.ready.then(() => ScrollTrigger.refresh(true));
}

export const MOTION_OK = '(prefers-reduced-motion: no-preference)';

export { gsap, ScrollTrigger, SplitText, useGSAP };
